import React from 'react';
import './styles.scss';
import { Outlet } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import { useQueryClient } from 'react-query';
import {
  Analytics, Clients, CoffeeMachine, Truck,
  CustomerSupport, Overview, Partners,
  Products, Routes, SmarterVending, Upload,
  UserManagement, VendingMachine, Warehouse, MapPin, PickingIcon, DriverStatusIcon,
} from '../../atoms/icons';
import { COLOR_PRIMARY } from '../../atoms/const';
import useSidebar from './hooks';
import Navigation from '../../molecules/navigations';

const Sidebar: React.FC = () => {
  const {
    show, onReverseShow, currentPath, setCurrentPath,
  } = useSidebar();

  const queryClient = useQueryClient();
  return (
    <div className="d-flex flex-row" style={{ height: '100%', minHeight: '100vh' }}>
      <div className="d-flex">
        <div className={`sideBar ${show ? 'sideBar-not-hide' : 'sideBar-hide'}`}>
          <div className="mt-4 mb-5">
            <Navigation.Title
              icon={<SmarterVending width={40} />}
              title="SmarterVending"
              show={show}
              onClick={onReverseShow}
            />
          </div>
          <div className="scroll">
            <Navigation.Link
              icon={<Overview width={22} />}
              title="Overview"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Analytics width={20} />}
              title="Analytics"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Clients width={15} color="white" />}
              title="Clients"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Partners width={20} />}
              title="Partners"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<VendingMachine width={17} />}
              title="Vending Machine"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Products width={20} />}
              title="Products"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Routes width={20} color="white" bg={COLOR_PRIMARY} opacity={1} />}
              title="Routes"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Warehouse width={20} />}
              title="Warehouse"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<CustomerSupport width={20} />}
              title="Customer Support"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<UserManagement width={20} />}
              title="User Management"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<CoffeeMachine width={20} />}
              title="Coffee Machine"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Truck width={20} />}
              title="Wholesale"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<PickingIcon width={20} />}
              title="Picking"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<DriverStatusIcon width={25} />}
              title="Driver"
              show={show}
              currentPath={currentPath}
            />
            <Navigation.Link
              icon={<Upload color="white" width={20} />}
              title="Upload"
              show={show}
              currentPath={currentPath}
            />
            <div className="d-flex justify-content-center text-white">
              <LogoutIcon
                onClick={() => {
                  queryClient.clear();
                  sessionStorage.clear();
                  window.location.reload();
                }}
                width={28}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <Outlet context={[currentPath, setCurrentPath]} />
      </div>
    </div>
  );
};

export default Sidebar;
